import { Component, OnInit } from '@angular/core';
import { ProductosService } from '../../services/productos.service';

@Component({
  selector: 'app-catalogo-productos',
  templateUrl: './catalogo-productos.component.html',
  styleUrls: ['./catalogo-productos.component.scss']
})
export class CatalogoProductosComponent implements OnInit {
    //Models
    public productos: any[] = [];

    //UI
    public modeFormulario: string = 'readonly';
    public permitirEditarProducto: boolean = true;
    public loading: boolean = false;
    public productoSeleccionado: any = null;
    public palabra_clave: string = '';

    //Filters
    public obraSelected: any = {};
    public proveedorSelected: any = {};
    public page: number = 1;

    //Paginacion
    public paginate: any = {};

    constructor(private produtosService: ProductosService
    ) {   
    }

    ngOnInit() {
      this.cargarProductos();
    }

    public cargarProductos(){
      this.loading = true;
      //TODO: Implementar paginación
      this.produtosService.listarProductos({ palabra_clave: this.palabra_clave })
      .subscribe(
          (response)=> {
              this.loading = false;
              let content = response.json().content;
              this.productos = content;
          
          },
          (error) => {
          this.loading = false;
          }
      );
    }

    public seleccionaProducto(producto){
        this.productoSeleccionado = producto.id_producto;
        this.modeFormulario = 'edit';
    }

    public agregarProducto(){
      this.modeFormulario = 'add';
      this.productoSeleccionado = null;
    }

    public productoGuardado(){
      this.modeFormulario = 'readonly';
      this.productoSeleccionado = null;
      this.cargarProductos();
    }
    public accionCancelada(){
      this.modeFormulario = 'readonly';
      this.productoSeleccionado = null;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/catalogo-productos/catalogo-productos.component.ts